import React, { useState } from "react";
import logo from "../img/enjuggernaut_logo.png";
import school_logo from "../img/student_logo.svg";
import book_logo from "../img/book_logo.svg";
import work_logo from "../img/work_logo.svg";
import upload from "../img/upload.svg";
import start_from_scratch from "../img/start_from_scratch.svg";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { AppState } from "../store";
import { User, UserScore, UserType } from "../Profile";
import BoxButton from "./BoxButton";
import "./Start.css";
import aerospace_logo from "../img/industry_logos/aerospace.svg";
import automotive_logo from "../img/industry_logos/automotive.svg";
import electronics_logo from "../img/industry_logos/electronics.svg";
import fintech_logo from "../img/industry_logos/fintech.svg";
import hardware_logo from "../img/industry_logos/hardware.svg";
import retail_logo from "../img/industry_logos/retail.svg";
import robotics_logo from "../img/industry_logos/robotics.svg";
import socialmedia from "../img/industry_logos/socialmedia.svg";

import devops from "../img/field_logos/devops.svg";
import firmware from "../img/field_logos/firmware.svg";
import computer_vision from "../img/field_logos/computer_vision.svg";
import database from "../img/field_logos/database.svg";
import frontend from "../img/field_logos/frontend.svg";
import backend from "../img/field_logos/backend.svg";
import full_stack from "../img/field_logos/full_stack.svg";
import network from "../img/field_logos/network.svg";
import security from "../img/field_logos/security.svg";
import machine_learning from "../img/field_logos/machine_learning.svg";
import robotics from "../img/field_logos/robotics.svg";
import embedded from "../img/field_logos/embedded.svg";
import { useAuthToken } from "../AuthProvider";
import arrow_back from "../img/arrow_back_gray.svg";
import { Subscription } from "../Subscription";
import {
  Box,
  Button,
  Step,
  StepLabel,
  Stepper,
  Typography,
  Drawer,
} from "@mui/material";
import { Sidebar } from "../Sidebar";
import { StepIconProps } from "@mui/material";
import { CustomStepIcon, CustomStepIconProps } from "../CustomStepIcon";
import BigBoxButton from "./BigBoxButton";
import { toast } from "react-toastify";

const steps = ["Field", "Industry", "Stage", "Resume"];

const fieldButtonProps = [
  {
    imageSrc: devops,
    text: "DevOps",
  },
  {
    imageSrc: firmware,
    text: "Firmware",
  },
  {
    imageSrc: computer_vision,
    text: "Computer Vision",
  },
  {
    imageSrc: database,
    text: "Database",
  },
  {
    imageSrc: frontend,
    text: "Frontend",
  },
  {
    imageSrc: backend,
    text: "Backend",
  },
  {
    imageSrc: full_stack,
    text: "Full Stack",
  },
  {
    imageSrc: network,
    text: "Network",
  },
  {
    imageSrc: security,
    text: "Security",
  },
  {
    imageSrc: machine_learning,
    text: "Machine Learning",
  },
  {
    imageSrc: robotics,
    text: "Robotics",
  },
  {
    imageSrc: embedded,
    text: "Embedded",
  },
];

const industryButtonProps = [
  {
    imageSrc: aerospace_logo,
    text: "Aerospace",
  },
  {
    imageSrc: automotive_logo,
    text: "Automotive",
  },
  {
    imageSrc: electronics_logo,
    text: "Electronics",
  },
  {
    imageSrc: fintech_logo,
    text: "Fintech",
  },
  {
    imageSrc: hardware_logo,
    text: "Computer Hardware",
  },
  {
    imageSrc: retail_logo,
    text: "Retail",
  },
  {
    imageSrc: robotics_logo,
    text: "Robotics",
  },
  {
    imageSrc: socialmedia,
    text: "Social Media",
  },
];

const stageButtonProps = [
  {
    imageSrc: book_logo,
    text: "College Student",
  },
  {
    imageSrc: school_logo,
    text: "New Grad",
  },
  {
    imageSrc: work_logo,
    text: "Working Professional",
  },
];

export function Start() {
  const dispatch = useDispatch();
  const userData = useSelector((state: AppState) => state.user); // get the current user object from the Redux store
  const navigate = useNavigate();
  const [isLoadingOverlayOpen, setIsLoadingOverlayOpen] = useState(false);
  const { isAuthenticated, token, isLoading, updateToken, isConfirmed } =
    useAuthToken();
  const [resumeCredits, setResumeCredits] = React.useState(0);
  const [isSubscriptionOverlayOpen, setIsSubscriptionOverlayOpen] =
    React.useState(false);
  const [activeStep, setActiveStep] = useState(0);
  const [completedSteps, setCompletedSteps] = useState<number[]>([]);
  const [isOpen, setIsOpen] = React.useState(false);

  async function getAccountInfo() {
    if (isLoading) {
      return;
    }

    const apiEndpoint =  "/api/accountinfo";

    let headers = {};

    if (!isAuthenticated) {
      setResumeCredits(1);
    } else {
      headers = {
        Authorization: `Bearer ${token}`,
      };

      try {
        // Make a POST request using fetch
        const response = await fetch(apiEndpoint, {
          method: "GET",
          headers: headers,
        });

        if (response.ok) {
          const responseData = await response.json();
          setResumeCredits(responseData.resume_credits);
        }
      } catch (error) {
        console.error("Error:", error);
        toast.error("An error occured.");
      }
    }
  }

  const hiddenFileInput = React.useRef<HTMLInputElement>(null);

  const handleClick = () => {
    if (hiddenFileInput.current) {
      hiddenFileInput.current.click();
    }
  };

  React.useEffect(() => {
    if (!isLoading) {
      getAccountInfo();
    }
  }, [isLoading]);

  const [activeIndustryButtonIndex, setActiveIndustryButtonIndex] = useState<
    number | null
  >(null);

  const [activeFieldButtonIndex, setActiveFieldButtonIndex] = useState<
    number | null
  >(null);

  const [activeStageButtonIndex, setActiveStageButtonIndex] = useState<
    number | null
  >(null);

  const navHome = () => {
    navigate("/");
  };

  const handleIndustryButtonClick = (index: number) => {
    setActiveIndustryButtonIndex(
      index === activeIndustryButtonIndex ? null : index
    );
    const updatedUser: User = {
      ...userData, // create a new object with all existing properties of the user object
      industry_index: index, // overwrite the name property with the new value
    };
    dispatch({
      type: "UPDATE_STATE",
      payload: updatedUser,
    });
  };

  const handleFieldButtonClick = (index: number) => {
    setActiveFieldButtonIndex(index === activeFieldButtonIndex ? null : index);
    const updatedUser: User = {
      ...userData, // create a new object with all existing properties of the user object
      field_index: index, // overwrite the name property with the new value
    };
    dispatch({
      type: "UPDATE_STATE",
      payload: updatedUser,
    });
  };

  const updateUserResume = (uuid: string) => {
    const updatedUser: User = {
      ...userData, // create a new object with all existing properties of the user object
      resume_uuid: uuid,
    };
    dispatch({
      type: "UPDATE_STATE",
      payload: updatedUser,
    });
  };

  const updateUserType = (index: number) => {
    let type: UserType = UserType.Unknown;

    if (index === 0) {
      type = UserType.Student;
    } else if (index === 1) {
      type = UserType.NewGrad;
    } else if (index === 2) {
      type = UserType.Professional;
    }

    const updatedUser: User = {
      ...userData, // create a new object with all existing properties of the user object
      user_type: type, // overwrite the name property with the new value
    };
    dispatch({
      type: "UPDATE_STATE",
      payload: updatedUser,
    });
  };

  function validateFileSize() {
    const fileInput = document.getElementById("fileInput") as HTMLInputElement;

    // Check if a file is selected
    if (fileInput.files && fileInput.files.length > 0) {
      const file = fileInput.files[0];

      // Check if the file size is within the allowed limit (1 MB)
      const maxFileSizeMB = 1;
      if (file.size > maxFileSizeMB * 1024 * 1024) {
        toast.error(
          `File size exceeds the maximum allowed (${maxFileSizeMB} MB)`
        );
        fileInput.value = ""; // Clear the file input
      } else {
        uploadFile();
      }
    }
  }

  async function uploadFile() {
    const fileInput = document.getElementById("fileInput") as HTMLInputElement;

    // Check if a file is selected
    if (fileInput.files && fileInput.files.length > 0) {
      const file = fileInput.files[0];

      // Create a FormData object and append the selected file
      const formData = new FormData();
      formData.append("pdfFile", file);
      formData.append("industry_index", String(userData.industry_index));
      formData.append("field_index", String(userData.field_index));
      formData.append("user_type", String(userData.user_type));

      const apiEndpoint =  "/api/resumes";

      setIsLoadingOverlayOpen(true);

      const headers = {
        Authorization: "",
      };

      if (isAuthenticated) {
        headers["Authorization"] = `Bearer ${token}`;
      }

      try {
        // Make a POST request using fetch
        const response = await fetch(apiEndpoint, {
          method: "POST",
          body: formData,
          headers: headers,
        });

        if (response.status == 423) {
          toast.error(`Input file does not seem to be a resume.`);
          fileInput.value = ""; // Clear the file input
        } else if (response.status == 405) {
          toast.error(`Please sign in to continue using enjuggernaut.`);
          fileInput.value = ""; // Clear the file input
        } else if (response.status == 406) {
          toast.error(`Insufficient resume credits.`);
          fileInput.value = ""; // Clear the file input
        }

        if (response.ok) {
          const responseData = await response.json();

          const uuid = responseData.uuid as string;
          updateUserResume(uuid);
          navigate("/score");
        } else {
          console.error("Error:", response.statusText);
        }
      } catch (error) {
        console.error("Error:", error);
        toast.error("An error occured.");
      }

      setIsLoadingOverlayOpen(false);
    } else {
      console.error("Please select a file.");
    }
  }

  const startFromScratch = () => {
    navigate("/details");
  };

  if (isLoading) {
    return <div></div>;
  }

  return (
    <div className="flex w-full flex-row justify-between">
      <div className="industry-panel min-h-screen w-full">
        {isSubscriptionOverlayOpen && (
          <div className="overlay z-10">
            <Subscription open_fn={setIsSubscriptionOverlayOpen} />
          </div>
        )}

        {isLoadingOverlayOpen && (
          <div className="overlay">
            <div className="agreement-content">
              <h2 className="attention-text font-bold">Score Loading...</h2>
              <h2 className="overlay-text font-bold">
                Please be patient, this could take about a minute...
              </h2>
              <h2 className="overlay-text">
                (We&apos;re running your resume through a bunch of AI
                algorithms)
              </h2>
              <div className="text-center">
                <div role="status">
                  <svg
                    aria-hidden="true"
                    className="inline h-8 w-8 animate-spin fill-blue-600 text-gray-200 dark:text-gray-600"
                    viewBox="0 0 100 101"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                      fill="currentColor"
                    />
                    <path
                      d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                      fill="currentFill"
                    />
                  </svg>
                  <span className="sr-only">Loading...</span>
                </div>
              </div>
            </div>
          </div>
        )}

        <header
          className={`header dark-panel visible sticky top-0 z-20 mx-auto flex flex-row items-center justify-between p-2 lg:hidden lg:p-4`}
        >
          <img src={logo} className="h-auto w-1/2" alt="logo" />

          <div>
            <button
              onClick={() => setIsOpen(!isOpen)}
              className="text-white hover:text-gray-300 focus:outline-none"
            >
              <svg
                fill="none"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                viewBox="0 0 24 24"
                stroke="currentColor"
                className="h-12 w-12"
              >
                {isOpen ? (
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M6 18L18 6M6 6l12 12"
                  />
                ) : (
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M4 6h16M4 12h16M4 18h16"
                  />
                )}
              </svg>
            </button>
          </div>
        </header>

        <button
          className="fixed ml-4 mt-4"
          onClick={() => {
            if (activeStep === 0) {
              if (isAuthenticated) {
                navigate("/resumes");
              } else {
                navigate("/");
              }
            } else {
              setActiveStep(activeStep - 1);
            }
          }}
        >
          <img className="scale-150" src={arrow_back} />
        </button>

        <Box sx={{ width: "100%", backgroundColor: "#333333", pt: 8, px: 2 }}>
          <Stepper activeStep={activeStep} sx={{ px: 10 }}>
            {steps.map((label, index) => (
              <Step key={index}>
                <StepLabel
                  StepIconComponent={(props) => (
                    <CustomStepIcon
                      {...props}
                      label={label}
                      activeColor="#ff8800" // Active color
                      inactiveColor="#F5F5F5" // Inactive color
                      setActiveStep={setActiveStep}
                      completedSteps={completedSteps}
                      stepIndex={index} // Current step index
                      activeStep={activeStep} // Active step index
                    />
                  )}
                ></StepLabel>
              </Step>
            ))}
          </Stepper>
          <Box sx={{}}>
            {activeStep === 0 && (
              <Box>
                <section
                  id="field_selector"
                  className="start-content industry-panel"
                >
                  <div className="flex w-full flex-1 flex-col-reverse md:flex-col">
                    <div className="flex flex-1 items-center justify-center px-4 py-8 lg:px-8 lg:py-12">
                      <div className="grid grid-cols-2 gap-x-8 gap-y-2 md:grid-cols-4 lg:grid-cols-6 2xl:gap-x-16 2xl:gap-y-12">
                        {[...Array(12)].map((_, field_index) => (
                          <BoxButton
                            key={field_index}
                            imageSrc={fieldButtonProps[field_index].imageSrc}
                            text={fieldButtonProps[field_index].text}
                            handleClick={() => {
                              handleFieldButtonClick(field_index);
                              setActiveStep(activeStep + 1);
                              setCompletedSteps(
                                completedSteps.concat(activeStep)
                              );
                            }}
                            isActive={activeFieldButtonIndex === field_index}
                          />
                        ))}
                      </div>
                    </div>
                    <h2 className="options-text pt-2 text-3xl lg:text-5xl xl:pt-6">
                      I want to be a __________ engineer.
                    </h2>
                  </div>
                </section>
              </Box>
            )}

            {activeStep === 1 && (
              <section className="start-content industry-panel">
                <div className="flex w-full flex-1 flex-col-reverse md:flex-col">
                  <div className="mt-10  flex flex-1 items-center justify-center px-4 py-4 lg:px-8 xl:py-8">
                    <div className="grid grid-cols-2 gap-x-16 gap-y-2 md:grid-cols-4 2xl:gap-x-24 2xl:gap-y-12">
                      {[...Array(8)].map((_, industry_index) => (
                        <BoxButton
                          key={industry_index}
                          imageSrc={
                            industryButtonProps[industry_index].imageSrc
                          }
                          text={industryButtonProps[industry_index].text}
                          handleClick={() => {
                            handleIndustryButtonClick(industry_index);
                            setActiveStep(activeStep + 1);
                            setCompletedSteps(
                              completedSteps.concat(activeStep)
                            );
                          }}
                          isActive={
                            activeIndustryButtonIndex === industry_index
                          }
                        />
                      ))}
                    </div>
                  </div>
                  <h2 className="options-text pt-16 text-3xl lg:text-5xl xl:pt-20">
                    I want to work in the ___________ industry.
                  </h2>
                </div>
              </section>
            )}

            {activeStep === 2 && (
              <div className="flex flex-col-reverse justify-around md:flex-col">
                <div className="mt-10 flex flex-1 items-center justify-center px-4 py-4 lg:px-8 xl:py-8">
                  <div className="grid grid-cols-1 gap-x-16 gap-y-2 md:grid-cols-3 xl:gap-x-24 xl:gap-y-12">
                    {[...Array(3)].map((_, stage_index) => (
                      <BigBoxButton
                        key={stage_index}
                        imageSrc={stageButtonProps[stage_index].imageSrc}
                        text={stageButtonProps[stage_index].text}
                        subtext=""
                        handleClick={() => {
                          updateUserType(stage_index);
                          setActiveStep(activeStep + 1);
                          setCompletedSteps(completedSteps.concat(activeStep));
                        }}
                        isActive={activeStageButtonIndex === stage_index}
                      />
                    ))}
                  </div>
                </div>
                <h2 className="options-text pt-20 text-3xl lg:text-5xl xl:pt-5 2xl:pt-32">
                  I am a ___________.
                </h2>
              </div>
            )}

            {activeStep === 3 && (
              <section id="input_selector" className="">
                <input
                  className="hidden"
                  type="file"
                  id="fileInput"
                  ref={hiddenFileInput}
                  accept=".pdf"
                  onChange={() => validateFileSize()}
                />

                <div className="mt-36 flex flex-col justify-around md:flex-row">
                  <BigBoxButton
                    key={0}
                    imageSrc={upload}
                    text={"Upload your resume"}
                    subtext="(PDF format only)"
                    handleClick={() => {
                      if (resumeCredits < 1) {
                        toast.error(
                          "Insufficient resume credits (consider enjuggernaut+)."
                        );
                        return;
                      }

                      if (isAuthenticated && !isConfirmed) {
                        toast.error(
                          "Please confirm your account (check your email)."
                        );
                        return;
                      }

                      handleClick();
                    }}
                    isActive={false}
                  />

                  <BigBoxButton
                    key={1}
                    imageSrc={start_from_scratch}
                    text={"Start from scratch"}
                    subtext=""
                    handleClick={() => {
                      if (resumeCredits < 1) {
                        toast.error(
                          "Insufficient resume credits (consider enjuggernaut+)."
                        );
                        return;
                      }

                      if (isAuthenticated && !isConfirmed) {
                        toast.error("Please confirm your account.");
                        return;
                      }

                      startFromScratch();
                    }}
                    isActive={false}
                  />
                </div>
              </section>
            )}
          </Box>
        </Box>
      </div>
      <Drawer anchor="right" open={isOpen} onClose={() => setIsOpen(false)}>
        <Sidebar minimized={true} drawer={true} />
      </Drawer>
      <Sidebar minimized={true} drawer={false} />
    </div>
  );
}
